import { render, staticRenderFns } from "./SkeletonBlock.vue?vue&type=template&id=14b83802&"
import script from "./SkeletonBlock.vue?vue&type=script&lang=ts&"
export * from "./SkeletonBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports